import React from 'react'
import Translation from '../General/Translation'

const MultisiteSelector =({multisiteSelector, cinemasSorted, currentCinemaId, toggleCinemaGroups, className, cinemaSelectorLogo, translation, siteName, theme, mobileClass=''}) => {
    if((!multisiteSelector || !multisiteSelector.hasOwnProperty('order') || multisiteSelector.order.length === 0 )&& !cinemasSorted) {
        return ''
    }

    const styles = cinemaSelectorLogo && theme && mobileClass === '' ? {
        backgroundColor: theme.accent_color_dark + '80'
    } : {
        backgroundColor: theme.accent_color_dark
    }

    return (
        <div className={"multisite-selector" + mobileClass + className}>
            <div className="multisite-toggle-button-wrapper">
                <div className="button multisite-toggle-button cursor-pointer accent-color-background " onClick={() => toggleCinemaGroups()}>
                    {!cinemaSelectorLogo && <div className='multisite-toggle-button-icon'>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.48 22.14">
                            <g id="Ebene_2" data-name="Ebene 2">
                                <g id="Ebene_1-2" data-name="Ebene 1">
                                    <path className="cls-1" d="M8.57,0C.87,0,0,7.11,0,8.49a10.14,10.14,0,0,0,1.34,5c1,1.8,7.48,8.66,7.48,8.66s6.83-8,7.16-8.65a9.26,9.26,0,0,0,1.5-4.58C17.48,6.66,16.27,0,8.57,0ZM14.7,12.73c-.28.55-5.89,7.12-5.89,7.12s-5.33-5.64-6.16-7.13a8.48,8.48,0,0,1-1.1-4.1c0-1.13.72-7,7.05-7S15.93,7.12,15.93,9A7.7,7.7,0,0,1,14.7,12.73Z"/>
                                    <path className="cls-1" d="M8.74,4.16a4.33,4.33,0,1,0,4.33,4.32A4.32,4.32,0,0,0,8.74,4.16Zm0,7.15a2.83,2.83,0,1,1,2.83-2.83A2.83,2.83,0,0,1,8.74,11.31Z"/>
                                </g>
                            </g>
                        </svg>
                    </div>}
                    {!cinemaSelectorLogo ? (<p className="text-large-medium "><Translation id="changeCinema" trans={translation}>KINO WECHSELN</Translation></p>):(<p className="text-large-medium toggle-button-text">{siteName.toUpperCase()}</p>)}
                </div>
            </div>
            <div className={'accent-color-background-dark multisite-blogs' + className} style={styles}>
                <ul>
                {cinemasSorted.map((cinema, index) => {
                        const {nameDisplay, website, pk} = cinema
                        const activeClass = currentCinemaId === pk ? ' active' : ''
                        return <li className="multisite-blog" key={index}><a className={"cursor-pointer text-large-medium" + activeClass} href={website}>{nameDisplay}</a></li>
                    }
                )}
                </ul>
            </div>
        </div>
    )
}


export default MultisiteSelector
